import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button } from '@mantine/core'

const defaultActive = [
    {
        label: 'Active',
        value: '1'
    },
    {
        label: 'Inactive',
        value: '0'
    },
]

const FormFilterCountry = ({ paramsFilter, applyFilter, onClose }) => {
    const [parameter, setParameter] = useState(paramsFilter)

    useEffect(() => {
        if (paramsFilter !== null) {
            setParameter(paramsFilter)
        }
    }, [paramsFilter])

    const handleChangeFilter = (name, val) => {
        setParameter((oldVal) => ({ ...oldVal, [name]: val }))
    }

    const handleApplyFilter = () => {
        const valueParams = {
            ...parameter,
            'page[num]': 1,
        }
        applyFilter(valueParams)
        onClose()
    }

    return (
        <Box>
            <Box mb='md'>
                <Select
                    label='Status'
                    placeholder='Select status'
                    data={defaultActive}
                    value={parameter['filter[status][is]']}
                    onChange={(val) => handleChangeFilter('filter[status][is]', val)}
                    clearable
                    size='xs'
                />
            </Box>
            <Box mt={20}>
                <Flex justify='flex-end'>
                    <Group>
                        <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
                        <Button size='xs' variant="filled" onClick={handleApplyFilter}>Apply Filter</Button>
                    </Group>
                </Flex>
            </Box>
        </Box>
    )
}

export default FormFilterCountry
